/** Expiration durations in seconds (for use with setLocalStorageWithExpiration / setCookieWithExpiration) */
export const THIRTY_DAYS_SECONDS = 30 * 24 * 60 * 60;
export const NINETY_DAYS_SECONDS = 90 * 24 * 60 * 60;

/** localStorage keys for attribution data */
export const ATTRIBUTION_KEYS = {
    SOURCE: 'kalshi_source',
    GCLID: 'kalshi_gclid',
    GBRAID: 'kalshi_gbraid',
    FBCLID: 'kalshi_fbclid',
    TTCLID: 'kalshi_ttclid',
    MSCLKID: 'kalshi_msclkid',
    DCLID: 'kalshi_dclid',
    RDT_CID: 'kalshi_rdt_cid',
    TWCLID: 'kalshi_twclid',
    SC_CID: 'kalshi_sccid',
    INITIAL_REFERRER: 'kalshi_initial_referrer',
    UTM_SOURCE: 'kalshi_utm_source',
    UTM_MEDIUM: 'kalshi_utm_medium',
    UTM_CAMPAIGN: 'kalshi_utm_campaign',
    UTM_CONTENT: 'kalshi_utm_content',
    UTM_TERM: 'kalshi_utm_term',
} as const;

// gbraid is Google's post-ATT iOS app-install click ID (web ad click → iOS app).
// Keep capturing it for the /install OneLink, but do not emit it as a signup
// header while the Google signup conversion action rejects braid identifiers.
export const CLICK_ID_PARAMS = [
    'gclid',
    'gbraid',
    'fbclid',
    'ttclid',
    'msclkid',
    'dclid',
    'rdt_cid',
    'twclid',
] as const;

/** Snapchat appends its click ID with non-lowercase casing (ScCid). It is
 * captured separately from CLICK_ID_PARAMS and stored under kalshi_sccid. */
export const SNAP_CLICK_ID_URL_PARAMS = ['ScCid', 'sccid', 'SCCID'] as const;
export type ClickIdParam = (typeof CLICK_ID_PARAMS)[number];

export const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const;
export type UtmParam = (typeof UTM_PARAMS)[number];
